import { FunctionComponent, ReactNode } from "react";

interface ISquareTileProps {
    children: ReactNode;
    title?: string;
    styles?: string;
}

const SquareTile: FunctionComponent<ISquareTileProps> = ({ children, title, styles }) => (
    <div data-testid='square-tile' className={`min-w-[450px] w-[100%] min-h-[400px] shadow-lg p-4 ${styles}`}>
        {title && <h2 className="font-sans text-center lg:text-left text-xl md:text-xl lg:text-2xl uppercase">{title}</h2>}
        {children}
    </div>
);

export default SquareTile;